import React, { Component } from "react";
import { Link, withRouter, Redirect } from "react-router-dom";

// Externals
import PropTypes from "prop-types";
import compose from "recompose/compose";
import validate from "validate.js";
import _ from "lodash";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  register as registerAction,
  confirmRegistration as confirmRegistrationAction,
  resendConfirmationCode as resendCodeAction,
  isLoading as loading
} from "../../redux/actions/authActions";

import { AUTH_ERROR_CLEAR } from "../../redux/actions/types";
import { store } from "../../index";

// Material helpers
import { withStyles } from "@material-ui/core";

// Material components
import { Box, Button, Checkbox, CircularProgress, Grid, IconButton, TextField, Typography } from "@material-ui/core";

// Material icons
import { ArrowBack as ArrowBackIcon } from "@material-ui/icons";

// Shared utilities
import validators from "../../common/validators";

// Component styles
import styles from "./styles";

// Form validation schema
import schema from "./schema";
import PopUpMessages from "../../components/PopUpMessages/PopUpMessages";
import { removeMessage } from "../../redux/actions/commonActions";
// Site config
import {getEnvironmentName} from "../../utils"
const environment = getEnvironmentName()

validate.validators.checked = validators.checked;

// Service methods
// const signUp = () => {
//   return new Promise(resolve => {
//     setTimeout(() => {
//       resolve(true);
//     }, 1500);
//   });
// };


const config = require("../../app_configuration").CONFIGURATION[environment];

class SignUp extends Component {
  // constructor(props) {
  //   super(props);
  // }

  state = {
    values: {
      email: "",
      password: "",
      confirmPassword: "",
      code: "",
      policy: false
    },
    touched: {
      email: false,
      password: false,
      code: false,
      confirmPassword: false,
      policy: null
    },
    errors: {
      email: null,
      password: null,
      confirmPassword: null,
      code: null,
      policy: null
    },
    isValid: false,
    dissableSignUp: config.SIGNUP_DISSABLED === true
    // isLoading: false,
  };

  // componentWillUnmount() {
  //   // dispatch clear error message before unmount, sign-in sign-up screen switch
  //   store.dispatch(function(dispatch) {
  //     // ... which themselves may dispatch many times
  //     dispatch({ type: AUTH_ERROR_CLEAR });
  //   });
  // }

  componentDidMount() {
    store.dispatch(function(dispatch) {
      // ... which themselves may dispatch many times
      dispatch({ type: AUTH_ERROR_CLEAR });
    });
  }

  handleBack = () => {
    const { history } = this.props;

    history.goBack();
  };

  validateForm = _.debounce(() => {
    const { values } = this.state;

    const newState = { ...this.state };
    const errors = validate(values, schema);

    newState.errors = errors || {};
    newState.isValid = errors ? false : true;

    this.setState(newState);
  }, 300);

  handleFieldChange = (field, value) => {
    const newState = { ...this.state };

    newState.touched[field] = true;
    newState.values[field] = value;

    this.setState(newState, this.validateForm);
  };

  handleSignUp = e => {
    e.preventDefault();
    this.props.loading(true);
    // dispatch clear error message before unmount, sign-in sign-up screen switch
    store.dispatch(function(dispatch) {
      // ... which themselves may dispatch many times
      dispatch({ type: AUTH_ERROR_CLEAR });
    });
    try {
      // const { history } = this.props;

      // this.setState({ isLoading: true });

      this.onFormSubmit(this.state.values.email, this.state.values.password, this.state.values.code);

      // await signUp({
      //   email: values.email
      // });

      // history.push("/sign-in");
    } catch (error) {
      this.setState({
        // isLoading: false,
        serviceError: error
      });
    }
  };

  // dispatchResetError = () => {
  //   let counter = 6;
  //   const seconds = setInterval(() => {
  //     if (counter === 0) {
  //       clearInterval(seconds);
  //       // dispatch INIT_STATE
  //       console.log("Login.dispatchInitState() dispatching INIT_STATE");
  //       store.dispatch({ type: AUTH_ERROR_CLEAR });
  //     }
  //     counter = counter - 1;
  //   }, 1000);
  // };

  // renderAlert() {
  //   // consume errorMessage and then dispatch event after 4 seconds to clear the state such
  //   // that message disappears from the screen
  //   const { errorMessage } = this.props;
  //
  //   if (typeof errorMessage !== "undefined" && errorMessage !== "") {
  //     console.error("Login.renderAlert(): error! message: ", errorMessage);
  //     this.dispatchResetError();
  //
  //     return errorMessage;
  //   }
  // }

  onFormSubmit(email, password, code) {
    console.log("Register.onFormSubmit() email, pwd, code :", email, password, code);

    const mfaRequired = this.props.mfaRequired;
    const resendCode = this.props.resendCode;

    console.log("mfaRequired | resendCode", mfaRequired, resendCode);

    if (
      typeof mfaRequired == "undefined" ||
      mfaRequired === false
      // && (typeof resendCode == "undefined" || resendCode == false)
    ) {
      // we pass in the history function so we can navigate from loginAction
      this.props.registerAction(email, password, this.props.history);
    } else if (mfaRequired === true && (typeof resendCode === "undefined" || resendCode === false)) {
      console.log("Login.onFormSubmit(): invoking setPasswordAction()");
      const { cognitoUser } = this.props;

      this.props.confirmRegistrationAction({ cognitoUser, code, email, password }, this.props.history);
    }
    // else if (mfaRequired === true && resendCode === true) {
    //   console.log("Login.onFormSubmit(): invoking resendCodeAction()");
    //   const { cognitoUser } = this.props;
    //
    //   this.props.resendCodeAction({ cognitoUser }, this.props.history);
    // }
  }

  handleResendVerificationCode = () => {
    const { cognitoUser } = this.props;
    this.props.resendCodeAction({ cognitoUser }, this.props.history);
  };

  render() {
    if (this.state.dissableSignUp) return <Redirect to="/" />;

    const { classes, isLoading, errorMessage, message, removeMessage } = this.props;
    const { values, touched, errors, isValid } = this.state;

    const showEmailError = touched.email && errors.email ? errors.email[0] : false;
    const showPolicyError = touched.policy && errors.policy ? errors.policy[0] : false;
    const showPasswordError = touched.password && errors.password ? errors.password[0] : false;
    const showConfirmPasswordError =
      touched.confirmPassword && errors.confirmPassword ? errors.confirmPassword[0] : false;

    const { mfaRequired, resendCode } = this.props;
    // const mfaRequired = true;

    // const invalidRegistration = this.renderAlert();

    return (
      <div className={classes.root}>
        <Grid className={classes.grid} container>
          <Grid className={classes.quoteWrapper} item lg={5}>
            <div className={classes.quote}>
              <div className={classes.quoteInner}>
                <Typography className={classes.quoteText} variant="h2">
                  Access any work system, or software, with plain English.
                </Typography>
                <Typography className={classes.quoteText} variant="h1">
                  <b>Just Ask.</b>
                </Typography>
                <div className={classes.person}>
                  <Typography className={classes.name} variant="body1">
                    Responsum.ai
                  </Typography>
                </div>
              </div>
            </div>
          </Grid>
          <Grid className={classes.content} item lg={7} xs={12}>
            <div className={classes.content}>
              <div className={classes.contentHeader}>
                <IconButton className={classes.backButton} onClick={this.handleBack}>
                  <ArrowBackIcon />
                </IconButton>
              </div>
              <div className={classes.contentBody}>
                {!mfaRequired && (
                  <form className={classes.form} onSubmit={this.handleSignUp}>
                    <Typography className={classes.title} variant="h2">
                      Create new account
                    </Typography>
                    <Typography className={classes.subtitle} variant="body1">
                      Use your work email to create new account... it's free.
                    </Typography>
                    <div className={classes.fields}>
                      <TextField
                        autoFocus
                        className={classes.textField}
                        label="Email address"
                        name="email"
                        onChange={event => this.handleFieldChange("email", event.target.value)}
                        value={values.email}
                        variant="outlined"
                      />
                      {showEmailError && (
                        <Typography className={classes.fieldError} variant="body2">
                          {errors.email[0]}
                        </Typography>
                      )}
                      <TextField
                        className={classes.textField}
                        label="Password"
                        onChange={event => this.handleFieldChange("password", event.target.value)}
                        type="password"
                        value={values.password}
                        variant="outlined"
                      />
                      {showPasswordError && (
                        <Typography className={classes.fieldError} variant="body2">
                          {errors.password[0]}
                        </Typography>
                      )}
                      <TextField
                        className={classes.textField}
                        label="Confirm password"
                        onChange={event => this.handleFieldChange("confirmPassword", event.target.value)}
                        type="password"
                        value={values.confirmPassword}
                        variant="outlined"
                      />
                      {showConfirmPasswordError && (
                        <Typography className={classes.fieldError} variant="body2">
                          {errors.confirmPassword[0]}
                        </Typography>
                      )}

                      <div className={classes.policy}>
                        <Checkbox
                          checked={values.policy}
                          className={classes.policyCheckbox}
                          color="primary"
                          name="policy"
                          onChange={() => this.handleFieldChange("policy", !values.policy)}
                        />
                        <Typography className={classes.policyText} variant="body1">
                          I have read the &nbsp;
                          <a href="https://responsum.ai/tos" target="__blank">
                            <Box component="Span" className={classes.policyUrl} variant="body1">
                              Terms and Conditions
                            </Box>
                          </a>
                        </Typography>
                      </div>
                      {showPolicyError && (
                        <Typography className={classes.fieldError} variant="body2">
                          {errors.policy[0]}
                        </Typography>
                      )}
                    </div>
                    {errorMessage && (
                      <Typography className={classes.submitError} variant="body2">
                        {errorMessage}
                      </Typography>
                    )}
                    {isLoading ? (
                      <CircularProgress className={classes.progress} />
                    ) : (
                      <Button
                        className={classes.signUpButton}
                        color="primary"
                        disabled={!isValid}
                        // onClick={this.handleSignUp}
                        size="large"
                        variant="contained"
                        type="submit"
                      >
                        Sign up now
                      </Button>
                    )}
                    <Typography className={classes.signUp} variant="body1">
                      Have an account?{" "}
                      <Link className={classes.signUpUrl} to="/sign-in">
                        Sign In
                      </Link>
                    </Typography>
                  </form>
                )}

                {mfaRequired && (
                  <form className={classes.form} onSubmit={this.handleSignUp}>
                    <Typography className={classes.title} variant="h2">
                      Verify your email
                    </Typography>
                    <Typography className={classes.subtitle} variant="body1">
                      Verification code has been sent on your email
                    </Typography>
                    <div className={classes.fields}>
                      <TextField
                        required
                        autoFocus
                        className={classes.textField}
                        label="Enter verification code"
                        name="code"
                        onChange={event => this.handleFieldChange("code", event.target.value)}
                        value={values.code}
                        variant="outlined"
                      />
                      {errorMessage && (
                        <Typography className={classes.submitError} variant="body2">
                          {errorMessage}
                        </Typography>
                      )}
                      {isLoading ? (
                        <CircularProgress className={classes.progress} />
                      ) : (
                        <React.Fragment>
                          <Button
                            className={classes.signUpButton}
                            color="primary"
                            disabled={!isValid}
                            // onClick={this.handleSignUp}
                            size="large"
                            variant="contained"
                            type="submit"
                          >
                            Verify
                          </Button>
                          <Typography className={classes.signUp} variant="h6">
                            Didn't get the code?{" "}
                            <Link className={classes.signUpUrl} onClick={this.handleResendVerificationCode}>
                              Resend
                            </Link>
                          </Typography>
                        </React.Fragment>
                      )}

                      {/*{resendCode && (*/}
                      {/*  <Button*/}
                      {/*    className={classes.signUpButton}*/}
                      {/*    color="primary"*/}
                      {/*    // onClick={this.handleSignUp}*/}
                      {/*    size="large"*/}
                      {/*    variant="contained"*/}
                      {/*    type="submit"*/}
                      {/*  >*/}
                      {/*    Resend Code*/}
                      {/*  </Button>*/}
                      {/*)}*/}
                    </div>
                  </form>
                )}
              </div>
            </div>
          </Grid>
          <PopUpMessages message={message} removeMessage={removeMessage} />
        </Grid>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  //console.log('Register.mapStateToProps() state:', state);
  //console.log('Register.mapStateToProps() ownProps:', ownProps);
  return {
    authenticated: state.auth.authenticated,
    errorMessage: state.auth.error,
    mfaRequired: state.auth.mfa_register,
    cognitoUser: state.auth.cognitoUser,
    resendCode: state.auth.resendCode,
    isLoading: state.auth.isLoading,
    message: state.common.message
  };
}

function mapDispatchToProps(dispatch) {
  //console.log('Register.mapDispatchToProps() ');
  // return {
  //   ...bindActionCreators(actionCreators, dispatch),
  //   dispatch
  // };

  return {
    ...bindActionCreators(
      {
        registerAction,
        confirmRegistrationAction,
        resendCodeAction,
        loading,
        removeMessage
      },
      dispatch
    ),
    dispatch
  };
}

SignUp.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  history: PropTypes.object,
  resendCode: PropTypes.bool,
  resendCodeAction: PropTypes.func,
  confirmRegistrationAction: PropTypes.func,
  cognitoUser: PropTypes.object,
  mfaRequired: PropTypes.bool,
  registerAction: PropTypes.func
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  compose(
    withRouter,
    withStyles(styles)
  )(SignUp)
);
